module.exports = __webpack_public_path__ + "img/dashboard_es.07d8a66.png";